import React, { useMemo, useRef } from 'react';
import Tablenization from '@icoach/components/Tablenization';
import { Chip } from "@curves/ui-base";
import { MoreLabelBox } from '@icoach/components/';
import { dialogType, orderStatusColorMap } from '@icoach/accountBook/staticData';
import { INVOICE_ALLOWANCE_TYPE } from '@icoach/constants/';
import { OrderAllowanceVoidDialog } from '@icoach/accountBook/dialog/';
import useToggleDialog from '@util/hook/useToggleDialog';
import { displayDateText } from '@util/moment';
import { formatCurrencyFn, isEqual } from '@util/utils';

const MORELABEL_KEY = {
	ALLOWANCEVOID: 'allowanceVoid'
};

const MoreLabel = props => {
	const { allowanceID, items, handleOpenDialog } = props;

	const moreLabelMemo = useMemo(
		() => {
			return {
				[MORELABEL_KEY.ALLOWANCEVOID]: {
					text: '作廢折讓',
					onClickEvent: () => handleOpenDialog(dialogType.allowanceVoid, { allowanceID, items })
				}
			};
		},
		// eslint-disable-next-line
		[allowanceID, items]
	);

	return <MoreLabelBox {...props} moreLabelMap={moreLabelMemo} textAlign="center" />;
};

export const rowsLabel = [
	{
		cellKey: 'allowanceDate',
		headerLabel: '折讓日期',
		width: 13,
		formatCell: cellValue => displayDateText(cellValue, null, { format: 'YYYY/MM/DD HH:mm' })
	},
	{
		cellKey: 'allowanceStatusText',
		headerLabel: '折讓狀態',
		align: 'center',
		formatCell: (cellValue, { allowanceStatus }) => {
			return <Chip label={cellValue} color={orderStatusColorMap.get(allowanceStatus)} />;
		}
	},
	{
		cellKey: 'allowanceAmount',
		headerLabel: '折讓金額',
		align: 'center',
		formatCell: cellValue => formatCurrencyFn(cellValue)
	},
	{
		cellKey: 'invoiceNo',
		headerLabel: '發票編號'
	},
	{
		cellKey: 'invoiceDate',
		headerLabel: '發票開立時間',
		formatCell: cellValue => displayDateText(cellValue, null, { format: 'YYYY/MM/DD HH:mm' })
	},
	{
		cellKey: 'more',
		headerLabel: '',
		align: 'right',
		isIcon: true,
		formatCell: (cellValue, rowData, { handleOpenDialog }) => {
			const { allowanceStatus } = rowData;
			if (isEqual(allowanceStatus, INVOICE_ALLOWANCE_TYPE.INVALIDALLOWANCE)) return null;
			return <MoreLabel {...rowData} moreActionArray={[MORELABEL_KEY.ALLOWANCEVOID]} handleOpenDialog={handleOpenDialog} />;
		}
	}
];

// 訂單折讓記錄
const OrderAllowanceRecordTable = props => {
	const { className, rowsData = [], refresh } = props;
	const { openTarget, handleOpenDialog, handleCloseDialog, allowanceID, items } = useToggleDialog();
	const labelTitle = useRef(rowsLabel);
	return (
		<React.Fragment>
			<Tablenization cardProps={{ className: className }}>
				<Tablenization.TableRowHeader headerRow={labelTitle.current} />
				<Tablenization.TableRowBody headerRow={labelTitle.current} rowsData={rowsData} handleOpenDialog={handleOpenDialog} />
			</Tablenization>
			<OrderAllowanceVoidDialog open={isEqual(openTarget, dialogType.allowanceVoid)} allowanceID={allowanceID} items={items} onClose={handleCloseDialog} refresh={refresh} />
		</React.Fragment>
	);
};

export default OrderAllowanceRecordTable;
